/* Variant/purchase logic is loaded only on product pages. */
(() => {
 'use strict';
 const qs=(s,root=document)=>root.querySelector(s);
 const qsa=(s,root=document)=>[...root.querySelectorAll(s)];
 const notify=message=>{const box=qs('.fl-notice');if(box){box.textContent=message;box.hidden=false;}};
  function initProduct(root = document) {
    qsa('[data-fellino-product]', root).forEach(product => {
      if (product.dataset.initialized) return;
      product.dataset.initialized = 'true';
      const text = key => product.getAttribute('data-i18n-' + key);
      const variants = JSON.parse(qs('[data-variant-data]', product).textContent);
      const form = qs('.fl-product-form', product);
      const idInput = qs('[data-variant-id]', form);
      const options = qsa('[data-product-option]', product);
      const mainAdd = qs('[data-add-to-cart]', product);
      const quantity = qs('[name="quantity"]', form);
      const price = qs('[data-product-price]', product);
      const message = qs('[data-variant-message]', product);
      const delivery = qs('[data-delivery]', product);
      let current = variants.find(v => String(v.id) === idInput.value);
      const showMedia = id => {
        const deferred = qs(`template[data-deferred-media="${id}"]`, product);
        if (deferred) { const fragment = deferred.content.cloneNode(true); deferred.replaceWith(fragment); }
        if (!qs(`[data-media-id="${id}"]`, product)) return;
        qsa('[data-media-id]', product).forEach(media => {
          media.hidden = media.dataset.mediaId !== String(id);
          if (media.hidden) qsa('video', media).forEach(video => video.pause());
        });
        qsa('[data-show-media]', product).forEach(button => button.setAttribute('aria-pressed', String(button.dataset.showMedia === String(id))));
      };
      product.addEventListener('click', event => {
        const button = event.target.closest('[data-show-media]');
        if (button) showMedia(button.dataset.showMedia);
      });
      qs('[data-load-thumbnails]', product)?.addEventListener('click', event => {
        const template = qs('[data-more-thumbnails]', product);
        if (template) template.replaceWith(template.content.cloneNode(true));
        event.currentTarget.hidden = true;
      });
      const update = (variant, pushUrl = true) => {
        current = variant;
        const available = !!variant?.available;
        [mainAdd].forEach(button => {
          if (!button) return;
          button.disabled = !available;
          qs('span', button).textContent = !variant ? text('unavailable') : available ? text('add') : text('sold-out');
        });
        idInput.disabled = !variant;
        delivery.dataset.deliveryState = available ? (variant.deliveryState || 'unknown') : 'unavailable';
        if (!variant) {
          price.querySelector('.fl-sale-summary')?.remove();
          price.querySelector('.fl-price')?.classList.remove('fl-price--sale');
          message.textContent = text('combination'); message.hidden = false;
          qs('[data-delivery] span', product).textContent = text('combination-short');
          return;
        }
        message.hidden = true;
        idInput.value = variant.id; idInput.dispatchEvent(new Event('change', {bubbles:true}));
        const discounted = variant.compare > variant.price;
        const row = document.createElement('div'); row.className = discounted ? 'fl-price fl-price--sale' : 'fl-price';
        const strong = document.createElement('strong'); strong.textContent = variant.priceText; row.append(strong);
        if (discounted) { const compare = document.createElement('s'); const label=document.createElement('span');label.className='fl-sr-only';label.textContent=text('compare');compare.append(label,document.createTextNode(variant.compareText));row.append(compare); }
        price.replaceChildren(row);
        if (variant.unitText) { const unit = document.createElement('small'); unit.className = 'fl-unit-price'; unit.textContent = variant.unitText; price.append(unit); }
        if (discounted) { const percent=Math.floor((variant.compare-variant.price)*100/variant.compare);const summary=document.createElement('p');summary.className='fl-sale-summary';const badge=document.createElement('strong');badge.className='fl-sale-pill';badge.textContent=percent>0 ? `SALE −${percent} %` : 'SALE';const saving=document.createElement('span');saving.textContent=text('savings').replace('__amount__', variant.savingsText);summary.append(badge,saving);price.append(summary); }
        qs('[data-delivery] span', product).textContent = variant.delivery;
        qs('[data-product-sku]', product).textContent = variant.sku || '–';
        quantity.min = variant.min; quantity.step = variant.increment;
        if (variant.max !== null && variant.max !== undefined) quantity.max = variant.max; else quantity.removeAttribute('max');
        let q = Math.max(variant.min, Number(quantity.value) || variant.min);
        q = variant.min + Math.ceil((q - variant.min) / variant.increment) * variant.increment;
        quantity.value = variant.max ? Math.min(q, variant.max) : q;
        if (variant.mediaId) showMedia(variant.mediaId);
        if (pushUrl) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
        // Standard event for existing product-option integrations. Native form submission is intentionally retained.
        document.dispatchEvent(new CustomEvent('variant:change', {detail:{variant:{...variant,id:variant.id},productId:product.dataset.productId}}));
      };
      options.forEach(option => option.addEventListener('change', () => update(variants.find(v => v.options.every((value, index) => value === options[index].value)))));
      window.addEventListener('popstate', () => {
        const id = new URL(location.href).searchParams.get('variant'); const variant = variants.find(v => String(v.id) === id);
        if (variant) { options.forEach((select, index) => select.value = variant.options[index]); update(variant, false); }
      });
      form.addEventListener('submit', event => {
        if (!current?.available) { event.preventDefault(); notify(text('select-available')); }
      });
    });
  }

 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initProduct());else initProduct();
 document.addEventListener('shopify:section:load',event=>initProduct(event.target));
})();
/* Product-only enhancements; all original image links and form controls remain fallbacks. */
(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('[data-fellino-product]').forEach(product => {
      if (product.dataset.toolsReady) return;
      product.dataset.toolsReady = 'true';
      const text = key => product.getAttribute('data-i18n-' + key);
      product.querySelectorAll('[data-size-guide]').forEach(link => link.addEventListener('click', event => {
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault(); target.open = true;
        target.scrollIntoView({behavior:'smooth', block:'start'});
        target.querySelector('summary')?.focus({preventScroll:true});
      }));
      const dialog = product.querySelector('[data-gallery-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const images = JSON.parse(product.querySelector('[data-gallery-images]').textContent);
      const image = dialog.querySelector('[data-gallery-image]');
      const stage = dialog.querySelector('[data-gallery-stage]');
      const zoom = dialog.querySelector('[data-gallery-zoom]');
      let index = 0, opener, previousOverflow = '', startX = 0, startY = 0, suppressClickUntil = 0, swipeAllowed = false;
      const setZoom = enabled => {
        dialog.classList.toggle('is-zoomed', enabled);
        image.setAttribute('aria-pressed', String(enabled));
        image.setAttribute('aria-label', enabled ? text('zoom-out') : text('zoom-in'));
        zoom?.setAttribute('aria-pressed', String(enabled));
        stage.scrollTo(0,0);
      };
      const show = requested => {
        index = (requested + images.length) % images.length; setZoom(false);
        image.src = images[index].src; image.alt = images[index].alt;
        dialog.querySelector('[data-gallery-caption]').textContent = `${index + 1} / ${images.length}`;
        dialog.querySelectorAll('[data-gallery-prev],[data-gallery-next]').forEach(button => { button.disabled = images.length < 2; button.hidden = images.length < 2; });
      };
      product.addEventListener('click', event => {
        const link = event.target.closest('[data-gallery-open]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const selected = images.findIndex(item => String(item.id) === link.dataset.galleryId);
        if (selected < 0) return;
        event.preventDefault(); suppressClickUntil = 0; opener = link; show(selected);
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden'; dialog.showModal();
        dialog.querySelector('[data-gallery-close]').focus();
      });
      dialog.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { document.documentElement.style.overflow = previousOverflow; setZoom(false); opener?.focus({preventScroll:true}); });
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      const toggleZoom = event => {
        const enabled = !dialog.classList.contains('is-zoomed');
        const rect = image.getBoundingClientRect();
        const x = event?.clientX !== undefined ? (event.clientX - rect.left) / rect.width : .5;
        const y = event?.clientY !== undefined ? (event.clientY - rect.top) / rect.height : .5;
        setZoom(enabled);
        if (enabled) stage.scrollTo(image.clientWidth * x - stage.clientWidth / 2, image.clientHeight * y - stage.clientHeight / 2);
      };
      zoom?.addEventListener('click', toggleZoom);
      image.addEventListener('click', event => { if (Date.now() > suppressClickUntil) toggleZoom(event); });
      image.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggleZoom(); }
      });
      dialog.querySelector('[data-gallery-prev]').addEventListener('click', () => show(index - 1));
      dialog.querySelector('[data-gallery-next]').addEventListener('click', () => show(index + 1));
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1)); }
      });
      stage.addEventListener('touchstart', event => { swipeAllowed=event.touches.length===1;startX=event.changedTouches[0].clientX;startY=event.changedTouches[0].clientY; }, {passive:true});
      stage.addEventListener('touchmove', event => { if(event.touches.length>1)swipeAllowed=false; }, {passive:true});
      stage.addEventListener('touchend', event => {
        if (!swipeAllowed || dialog.classList.contains('is-zoomed') || event.changedTouches.length !== 1) return;
        const dx=event.changedTouches[0].clientX-startX,dy=event.changedTouches[0].clientY-startY;
        if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)*1.5){suppressClickUntil=Date.now()+600;show(index+(dx<0?1:-1));}
      }, {passive:true});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
